import { Action } from '@ngrx/store';
import { RmsContractBalance, PaymentTerm, ContractOP, ProductOP } from '@cemex-core/cmx-api';

export enum ContractActionTypes {
  LOAD_AVAILABLE_CONTRACTS = '[RMS Open Platform Contract] Available contracts',
  LOAD_CONTRACT_BALANCE = '[RMS Open Platform Contract] Load balance',
  BALANCE_COMPLETED = '[RMS Open Platform Contract] Balance completed',
  LOAD_CONTRACT_PAYMENT_TERM = '[RMS Open Platform Contract] Load contract payment term',
  RESET = '[RMS Open Platform Contract] Reset',
}

export class LoadAvailableContracts implements Action {
  readonly type = ContractActionTypes.LOAD_AVAILABLE_CONTRACTS;

  constructor(
    public payload: {
      productCode: string;
      salesDocuments: ContractOP[];
    },
  ) {}
}

export class LoadBalanceContracts implements Action {
  readonly type = ContractActionTypes.LOAD_CONTRACT_BALANCE;

  constructor(public payload: ProductOP) {}
}

export class ContractBalanceCompleteAction implements Action {
  readonly type = ContractActionTypes.BALANCE_COMPLETED;
  constructor(
    public payload: {
      [agreementCode: string]: RmsContractBalance[];
    },
  ) {}
}
export class LoadContractPaymentTermAction implements Action {
  readonly type = ContractActionTypes.LOAD_CONTRACT_PAYMENT_TERM;
  constructor(public payload: PaymentTerm[]) {}
}

export class ContractsResetAction implements Action {
  readonly type = ContractActionTypes.RESET;

  constructor() {}
}

export type ContractActions =
  | LoadAvailableContracts
  | LoadBalanceContracts
  | ContractBalanceCompleteAction
  | LoadContractPaymentTermAction
  | ContractsResetAction;
